// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11b05eba","466":"800430c7","497":"bd1bd084","851":"748c99a5","936":"04b93a78"}[chunkId] + ".chunk.js";
};